export const TASK_ID_QUERY_KEY = 'taskId'
export const PROJECT_ID_QUERY_KEY = 'projectId'
export const CUSTOMER_ID_QUERY_KEY = 'customerId'
export const PAGE_ACTION_QUERY_KEY = 'pageAction'
export const TASK_NAME_QUERY_KEY = 'taskName'

export const CREATE_TASK_PAGE_ACTION = 'create_task'



// WEBPACK FOOTER //
// ./web/js/panels/urlHelper/constants.js